import Utils from '@/common/utils/utils';
import { IconButton } from '@material-ui/core';
import React from 'react';
import Constant from '../../../common/constant/Constant';

export default function DuplicateATicket({ corporationDetail, detailTicket, onClickDuplicate, formDetail, selectedProject }) {
    const isShowButtonDuplicate = () => {
        const knowledgeService = [
            Constant.CORPORATION_CONTRACT_TYPE.GUEST,
            Constant.CORPORATION_CONTRACT_TYPE.GUEST_DESK
        ].includes(corporationDetail.contractType)
            ? Utils.convertJSONDataToObject(corporationDetail?.inviterSetting)
                  ?.usingKnowledgeService
            : corporationDetail?.knowledgeService;
        // Check on knowledge service
        const isKnowledgeServiceOn = knowledgeService === Constant.STATUS_SERVICE_PERMISSION.ON;
        // Check type ticket 
        const isTicketTypeAllowDuplicate =
            [Constant.TICKET_TYPE.KNOWLEDGE, Constant.TICKET_TYPE.MASTER_KNOWLEDGE].includes(
                detailTicket.ticketType
            ) && !detailTicket.deletedAt;

        // Project base, B2C does not allow duplicates
        const isProjectAllowDuplicate = ![Constant.PROJECT_TYPE.BASE, Constant.PROJECT_TYPE.CUSTOMER].includes(selectedProject.type);

        // Corp support does not allow duplicates
        const isCorpAllowDuplicate = ![Constant.CORPORATION_CONTRACT_TYPE.GUEST].includes(corporationDetail.contractType);
        return (formDetail?.isFormShareForProject || detailTicket.public === Constant.TICKET_PUBLIC.DRAFT) && isKnowledgeServiceOn && isTicketTypeAllowDuplicate && isProjectAllowDuplicate && isCorpAllowDuplicate;
    };

    const onClickDuplicateATicket = () => {
        onClickDuplicate();
    }

    if (!isShowButtonDuplicate()) return null;
 
    return (
        // <Tooltip title="リンクをコピー" arrow={true} placement="bottom"> // Để bổ sung nếu sau yêu cầu tooltip
            <IconButton
                className="itemNav"
                onClick={onClickDuplicateATicket}
                data-cy="detail-ticket-icon-chat"
                disabled={false}
            >
                <img src="/assets/image/icon-copy.svg" alt="" />
            </IconButton>
        // </Tooltip>
    );
}
